import React, { useState, useEffect } from "react";
import { w2s } from "../../utils/coords";

export default function DimEditor({ editing, zoom, pan, onCommit, onCancel }) {
  const [val, setVal] = useState("");

  useEffect(() => {
    if (editing) setVal(String(editing.lenMm));
  }, [editing]);

  if (!editing) return null;
  const sp = w2s(editing.svgPt, pan, zoom);

  return (
    <div style={{ position: "absolute", left: sp.x - 60, top: sp.y - 18, zIndex: 50 }}>
      <input
        autoFocus
        value={val}
        onChange={e => setVal(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") { const n = parseInt(val, 10); if (n > 50) onCommit(n); else onCancel(); }
          if (e.key === "Escape") onCancel();
        }}
        onBlur={onCancel}
        style={{
          width: 130, padding: "5px 10px", background: "#0c1320",
          border: "1px solid #60a5fa", color: "#60a5fa", borderRadius: 5,
          fontSize: 12, fontFamily: "'JetBrains Mono',monospace",
          outline: "none", textAlign: "center", boxShadow: "0 4px 20px #000a",
        }}
      />
      <div style={{ fontSize: 8, color: "#3d5068", textAlign: "center", marginTop: 3 }}>
        mm · Enter to apply
      </div>
    </div>
  );
}
